// extracted by mini-css-extract-plugin
export default {"home":"Home_home__m+Y9x","articles_layout":"Home_articles_layout__9fdc0"};